import {formatDate, formatDocumentOrganizationUnit} from "utils/valueFormatter.function";
import type {DocumentDetailsProps} from "types/documentData";
import {DocumentDataField, DocumentDataGrid} from "./DocumentDataField.component";
import {getDisplayId} from "./documentData.function";

// a count of 0 is still shown, only a missing one is not
const hasCount = (count?: number | null) => typeof count === "number" && count >= 0;

const LeaveRequestDocumentDetailsDTO = ({details, translate}: DocumentDetailsProps) => (
    <DocumentDataGrid>
        {details.description &&
            <DocumentDataField id="description" wide label={translate("documentData.description")}
                               value={details.description}/>}
        {details.userName &&
            <DocumentDataField id="requester" label={translate("documentData.requester")} value={details.userName}/>}
        {!!details.employeeCode &&
            <DocumentDataField id="employeeCode" label={translate("documentData.employeeCode")}
                               value={details.employeeCode}/>}
        <DocumentDataField id="documentId" label={translate("documentData.documentID")} value={getDisplayId(details)}/>
        {details.documentOrganizationUnit &&
            <DocumentDataField id="organizationUnit" label={translate("documentData.organizationUnit")}
                               value={formatDocumentOrganizationUnit(details.documentOrganizationUnit)}/>}
        {Number(details.receivedDate) > 0 &&
            <DocumentDataField id="receivedDate" dataCy="documentData.receivedDate"
                               label={translate("documentData.receivedDate")} value={formatDate(details.receivedDate, null)}/>}
        {Number(details.dueDate) > 0 &&
            <DocumentDataField id="dueDate" dataCy="documentData.dueDate"
                               label={translate("documentData.dueDate")} value={formatDate(details.dueDate, null)}/>}
        {Number(details.fromDate) > 0 &&
            <DocumentDataField id="fromDate" dataCy="documentData.fromDate"
                               label={translate("documentData.fromDate")} value={formatDate(details.fromDate, null)}/>}
        {Number(details.toDate) > 0 &&
            <DocumentDataField id="toDate" dataCy="documentData.toDate"
                               label={translate("documentData.toDate")} value={formatDate(details.toDate, null)}/>}
        {details.eventCode &&
            <DocumentDataField id="eventCode" label={translate("documentData.eventCode")} value={details.eventCode}/>}
        {hasCount(details.numberOfDays) &&
            <DocumentDataField id="numberOfDays" dataCy="documentData.numberOfDays"
                               label={translate("documentData.numberOfDays")} value={details.numberOfDays}/>}
        {hasCount(details.numberOfHours) &&
            <DocumentDataField id="numberOfHours" dataCy="documentData.numberOfHours"
                               label={translate("documentData.numberOfHours")} value={details.numberOfHours}/>}
    </DocumentDataGrid>
);

export default LeaveRequestDocumentDetailsDTO;
